import { render, staticRenderFns } from "./DashboardOrdersGraph.vue?vue&type=template&id=0e61ba1d&scoped=true"
import script from "./DashboardOrdersGraph.vue?vue&type=script&lang=js"
export * from "./DashboardOrdersGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e61ba1d",
  null
  
)

export default component.exports